
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chatwhatsapp",
      function () {
        return require("private-next-pages/chatwhatsapp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chatwhatsapp"])
      });
    }
  